import { getProductCatalogueApiConfig } from '../config/actions';
import { SearchUrlSuffix } from '../models/search-url-suffix';
/**
 * @internal
 */
export var getFetchSearchUrl = function (searchUrlSuffix, includeType) {
    if (searchUrlSuffix === void 0) { searchUrlSuffix = SearchUrlSuffix.Prioritize; }
    if (includeType === void 0) { includeType = "available" /* Available */; }
    var baseUrl = getProductCatalogueApiConfig().baseUrl;
    var relativeUrl = getFetchSearchRelativeUrl(searchUrlSuffix, includeType);
    return baseUrl + "/" + relativeUrl;
};
/**
 * @internal
 */
export var getFetchSearchRelativeUrl = function (searchUrlSuffix, includeType) {
    if (searchUrlSuffix === void 0) { searchUrlSuffix = SearchUrlSuffix.Prioritize; }
    if (includeType === void 0) { includeType = "available" /* Available */; }
    return "v1/search/" + searchUrlSuffix + "?include=" + includeType;
};
